import React from "react";

const TopBlog = ({ blog, excerpt }) => {
  if (!blog?.id) return null;

  return (
    <article className="notes__entry">
      <h3 className="notes__entry-title">
        <a href={blog.canonical_url} target="_blank" rel="noreferrer">
          {blog.title}
        </a>
      </h3>
      {excerpt ? <p className="notes__excerpt">{excerpt}</p> : null}
      <p className="notes__meta">dev.to</p>
    </article>
  );
};

export default TopBlog;
